import { useMemo } from "react";

import { useSelector } from "react-redux";
import { dispatch } from "../../state/store";
import {
  insertConsentElement,
  alignConsentElementTexts,
  pushCreatedTableRowsIds,
  setConsentElementsVisibility
} from "../../state/ducks";

import { alignItems, strCode } from "../../consts";
import { t } from "../../services";
import { consentUtil } from "../../utils";
import { withSection } from "../../hoc";

import { NewConsentForm } from "../../containers";
import {
  AppManagementBreadcrumbs,
  FlexContainers,
  Heading5,
  PageContainer,
  WrapperContainer
} from "../../components";

const CreateConsentElementPage = () => {
  const consentElements = useSelector((store) => store.consents.consentElements);
  const consentElementsVisibility = useSelector(
    (store) => store.consents.consentElementsVisibility
  );

  const newConsentPosition = useMemo(() => {
    return consentElements?.length ?? 0;
  }, [consentElements]);

  const onCreateConsentElement = (consent, isVisible) => {
    const createdAtTs = new Date().getTime();

    const newId = consentUtil.getNewConsentElementId(consentElements);
    const newConsentElement = { ...consent, id: newId, createdAtTs, updatedAtTs: createdAtTs };

    dispatch(pushCreatedTableRowsIds([newId]));
    dispatch(insertConsentElement(newConsentElement));

    if (isVisible) {
      dispatch(alignConsentElementTexts(newConsentElement));
    }

    dispatch(setConsentElementsVisibility(isVisible));
  };

  return (
    <PageContainer alignItems={alignItems.start}>
      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        width="100%"
        height="100%">
        <AppManagementBreadcrumbs />

        <Heading5>{t(strCode.NEW_CONSENT_ELEMENT)}</Heading5>

        <NewConsentForm
          onSaveConsent={onCreateConsentElement}
          consentPosition={newConsentPosition}
          isToggleVisibilityDisabled={
            consentElementsVisibility !== null && consentElements?.length > 0
          }
        />
      </WrapperContainer>
    </PageContainer>
  );
};

export default withSection(CreateConsentElementPage);
